import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'

import ProtectedComponent from '../../../generic/ProtectedComponent'
import MainContent from '../../MainContent'
import { Box } from '../../../generic/Box'
import Title from '../../../generic/Title'
import UsersTable from './UsersTable'
import EditUsersModal from './EditUsersModal'

const ConfigUsers = inject('configUsersStore')(observer(
  class ConfigUsers extends Component {
    constructor (props) {
      super(props)
      const { configUsersStore } = this.props
      if (!configUsersStore.state.users.length) {
        configUsersStore.fetchAllUsers()
      }
    }

    render () {
      return (
        <ProtectedComponent permission='configure_users'>
          <MainContent>
            <Box>
              <Title>Configurar usuários</Title>
              <UsersTable />
            </Box>
          </MainContent>
          <EditUsersModal />
        </ProtectedComponent>
      )
    }
  }
))

export default ConfigUsers



// WEBPACK FOOTER //
// ./src/components/dashboard/config/users/ConfigUsers.js